module.exports = __webpack_public_path__ + "static/media/googleplay-en.80e29d3b.png";